// src/constants/userRoles.js

const UserRoles = Object.freeze({
  SUPER_ADMIN: { id: 1, value: "SuperAdmin" },
  MANAGER: { id: 2, value: "Manager" },
  VALIDATOR: { id: 3, value: "Validator" },
});

export default UserRoles;
